import React, { useContext, useEffect, useMemo, useState } from 'react'
import {
  Table,
  TableContainer,
  Paper,
  TablePagination,
  makeStyles,
} from '@material-ui/core'
import MTableHead from './mtable/MTableHead'
import MTableBody from './mtable/MTableBody'
import MTableButton from './mtable/MTableButton'
import objectPath from 'object-path'
import { DesignContext } from 'contexts/DesignContext'
import { createTableStyle } from './Action'
import { isEmpty } from 'designer/component/action/condition/State'
import ActionsComponent from './mtable/ActionsComponent'
import { genRefId, getRowId } from './action/index'
import { generateString } from 'designer/component/action/Data'
import { checkCrudCondition } from './action/Crud'
import { useRouteMatch, useLocation } from 'react-router-dom'
import { setApi } from 'designer/component/action/Api'
import httpClient from 'utility/httpClient.util'
import cloneDeep from 'clone-deep'
import ModalTable from 'designer/component/component/ModalTable'
import { onCheckCondition } from 'designer/component/action/condition/Action'

const useStyles = makeStyles({
  selectRoot: {
    width: 100,
    minWidth: 100,
  },
  selectMenuPaper: {
    width: 100,
    minWidth: 100,
    maxWidth: 100,
  },
  selectMenuList: {
    width: 100,
    minWidth: 100,
    maxWidth: 100,
  },
})

const MTableArray = (props) => {
  let { uischema, config } = props
  let { isFavoriteModal } = config

  const match = useRouteMatch()
  const location = useLocation()
  let receivePathParams = match.params
  let urlSearchParams = new URLSearchParams(location.search || [])
  let receiveQueryParams = Object.fromEntries([...urlSearchParams])
  let allParams = { ...receivePathParams, ...receiveQueryParams }

  const tableAction = uischema?.tableAction?.action || []
  const deleteAction = tableAction.find((action) => action.name === 'delete')
  const columnRefId = objectPath.get(uischema, 'loadData.columnRefId')

  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    getCurrentUi,
    isUiChanged,
    setFieldFormData,
    setIsUiChanged,
    elementAction,
    currentSearch,
  } = designContext
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  const datasourceValue = objectPath.get(designContext, '@datasource') || {}
  const formData = jsonForm.formData
  let activeTabState = objectPath.get(isUiChanged, ['activeTab']) || {}
  let isRenderTable = objectPath.get(isUiChanged, [
    `isRenderTable`,
    uischema.key,
  ])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = hasEnable
    ? objectPath.get(elementAction, ['isEnable', uischema.key])
    : true
  const isReadOnly = !isEnable

  const [tableColumn, setTableColumn] = useState([])
  const [columnRequire, setColumnRequire] = useState([])
  const [editData, setEditData] = useState({})
  const [tableData, setTableData] = useState([])
  const [openModalTable, setOpenModalTable] = useState(false)
  const [modalTableState, setModalTableState] = useState({})
  const [inputSearch, setInputSearch] = useState({})
  const [totalCount, setTotalCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [render, setRender] = useState(false)
  const [dataRowSelected, setDataRowSelected] = useState({})

  const stateParent = {
    inputSearch: [inputSearch, setInputSearch],
    tableData: [tableData, setTableData],
    totalCount: [totalCount, setTotalCount],
    loading: [loading, setLoading],
    render: [render, setRender],
    dataRowSelected: [dataRowSelected, setDataRowSelected],
  }

  let isRender = objectPath.get(isUiChanged, `${uischema.key}.isRender`)

  useEffect(() => {
    if (isRender) {
      let tableData =
        objectPath.get(formData, uischema.name) ||
        objectPath.get(formData, uischema.key) ||
        []
      checkTableLength(tableData)
      objectPath.del(isUiChanged, [`isRender`, uischema.key])
      setIsUiChanged(isUiChanged)
    }
  }, [isRender])

  const visibleRowCount = useMemo(() => {
    return (tableData || []).filter((rowData) => {
      return !objectPath.get(rowData, '@isDeleted')
    }).length
  }, [tableData, isRender])

  const count = visibleRowCount

  let isOpenModalTable = objectPath.get(isUiChanged, [
    'openModalTable',
    uischema.key,
  ])
  let modalAction = objectPath.get(isUiChanged, ['modalAction', uischema.key])

  useEffect(() => {
    if (isOpenModalTable) {
      setOpenModalTable(true)
      objectPath.del(isUiChanged, ['openModalTable', uischema.key])
      setIsUiChanged(isUiChanged)
    }
  }, [isOpenModalTable])

  const [rowsPerPage, setRowsPerPage] = useState(uischema?.rowsPerPage || 5)
  const [page, setPage] = useState(0)

  const rowsPerPageOptions = useMemo(() => {
    let array = [5, 10, 20]
    if (uischema?.rowsPerPage) {
      if (!array.includes(uischema?.rowsPerPage)) {
        array.push(uischema?.rowsPerPage)
      }
    }
    return array.sort((a, b) => a - b)
  }, [uischema?.rowsPerPage])

  useEffect(() => {
    if (uischema?.rowsPerPage && rowsPerPage !== uischema?.rowsPerPage) {
      setRowsPerPage(uischema?.rowsPerPage)
    }
  }, [uischema?.rowsPerPage, rowsPerPage])

  const [changeSearch, setChangeSearch] = useState(false)
  useEffect(() => {
    if (changeSearch) {
      setChangeSearch(false)
    }
  }, [changeSearch])

  const search = useMemo(() => {
    let search = jsonForm.search || {}
    let searchTable = jsonForm.searchTable || []
    let foundSearch = searchTable.find(
      ({ tableKey }) => tableKey === uischema.key,
    )
    if (foundSearch) {
      search = foundSearch
    } else if (currentSearch?.uiKey && currentSearch?.search) {
      search = currentSearch?.search
      setChangeSearch(currentSearch?.uiKey)
    }
    return search
  }, [currentSearch?.uiKey])

  // Pagination
  const actionState =
    objectPath.get(isUiChanged, ['tableState', uischema.key]) || {}
  const addState = objectPath.get(actionState, 'add')
  const { isPaging, startRow = 0 } = uischema || {}

  const handleChangePage = (event, newPage) => setPage(newPage)
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0) // reset ไปหน้าแรก
  }

  const updateFormData = (tableData, state = {}) => {
    let { isDelete = false } = state
    setFieldFormData(uischema.name, tableData)
    setFieldFormData(uischema.key, tableData)
    setTableCache(getCurrentTableCacheKey(), tableData, false)
    if (isDelete) {
      objectPath.set(formData, uischema.key, tableData)
      onCheckCondition(designContext, formData, uischema.key, {
        isOnChange: true,
      })
    }
  }

  const handleAdd = () => {
    let dataUpdate = [...tableData]
    let genId = generateString(10)
    let newRow = {}
    objectPath.set(newRow, genRefId, genId)
    objectPath.set(newRow, `@seq`, count + 1)
    dataUpdate.push(newRow)
    setTableData(dataUpdate)
    const totalPages = Math.ceil((count + 1) / rowsPerPage)
    setPage(totalPages - 1)
    updateFormData(dataUpdate)
  }

  const getRowIndex = (dataUpdate, rowData) => {
    let index = -1
    let genId = objectPath.get(rowData, genRefId)
    let rowId = objectPath.get(rowData, columnRefId)
    if (columnRefId && rowId) {
      index = dataUpdate.findIndex((data) => {
        return objectPath.get(data, columnRefId) === rowId
      })
    } else if (genId) {
      index = dataUpdate.findIndex((data) => {
        return objectPath.get(data, genRefId) === genId
      })
    } else {
      index = dataUpdate.findIndex((rowData) => getRowId(rowData) !== rowId)
    }
    return { rowId, genId, index }
  }

  const onEditRow = (rowData) => {
    let dataUpdate = [...tableData]
    let { index } = getRowIndex(dataUpdate, rowData)
    if (index > -1) {
      objectPath.set(dataUpdate, index, rowData)
      setTableData(dataUpdate)
    }
    updateFormData(dataUpdate)
  }

  const handleDelete = (rowData) => {
    let dataUpdate = [...tableData]
    let { rowId, genId, index } = getRowIndex(dataUpdate, rowData)
    if (index > -1) {
      let { statusValue, statusField, isDeleteMode } = deleteAction || {}
      let newData = rowData
      if (isDeleteMode === 'on' || isDeleteMode === true) {
        if (rowId) {
          objectPath.set(newData, `@isDeleted`, true)
          objectPath.set(newData, statusField, statusValue)
          objectPath.set(dataUpdate, index, newData)
        } else {
          objectPath.del(dataUpdate, index)
        }
      } else if (genId) {
        objectPath.del(dataUpdate, index)
      } else {
        objectPath.del(dataUpdate, index)
      }
      setTableData(dataUpdate, true)
    }
    updateFormData(dataUpdate, { isDelete: true })

    onCheckCondition(designContext, formData, uischema.key)
  }

  const tableColumnList = objectPath.get(uischema, 'tableColumn') || []
  const tableColumnListString = JSON.stringify(tableColumnList)
  const activeTabStateString = JSON.stringify(activeTabState)
  let { action = [], optional = [] } = uischema.tableAction
  let isActiveUpdate = action.find(
    ({ isActive, name }) => isActive && name === 'update',
  )
  let isActiveDelete = action.find(
    ({ isActive, name }) => isActive && name === 'delete',
  )
  let activeIcon = optional.filter(
    ({ actionType }) => actionType === 'showIcon',
  )
  let activeOptional = optional.filter(
    ({ actionType }) => actionType !== 'showIcon',
  )
  let showAction =
    isActiveUpdate ||
    isActiveDelete ||
    activeIcon.length > 0 ||
    activeOptional.length > 0

  const addStartRow = (tableData, diffLength) => {
    if (diffLength > 0) {
      let genId = generateString(10)
      let newRow = {}
      objectPath.set(newRow, genRefId, genId)
      tableData.push(newRow)
      diffLength--
      return addStartRow(tableData, diffLength)
    }
    tableData.map((row, index) => {
      objectPath.set(row, genRefId, generateString(10))
      objectPath.set(row, '@seq', index + 1)
      return row
    })
    return tableData
  }

  const getLoadTableApi = (action) => {
    return setApi(action, formData, { formData, datasourceValue, allParams })
  }

  const getTableCache = (cacheKey) => {
    if (!cacheKey) return
    return objectPath.get(isUiChanged, ['tableCache', uischema.key, cacheKey])
  }

  const hasTableCache = (cacheKey) => {
    if (!cacheKey) return false
    return objectPath.has(isUiChanged, ['tableCache', uischema.key, cacheKey])
  }

  const setTableCache = (cacheKey, tableData, isDispatch = true) => {
    if (!cacheKey) return
    objectPath.set(isUiChanged, ['tableCache', uischema.key, cacheKey], tableData)
    if (isDispatch) {
      setIsUiChanged(isUiChanged)
    }
  }

  const getCurrentTableCacheKey = () => {
    let filterApi = checkCrudCondition({
      action: uischema.loadData,
      designContext,
      allParams,
    })
    if (filterApi?.length > 0) {
      return getLoadTableApi(filterApi[0])
    }
  }

  const loadTableData = async (action, api) => {
    api = api || getLoadTableApi(action)
    if (api) {
      let { headers = [] } = action
      let config = {}
      if (headers.length > 0) {
        headers.forEach(({ key, value }) => {
          if (key) {
            objectPath.set(config, `headers.${key}`, value)
          }
        })
      }
      let dataKey = action.data
      return await httpClient
        .get(api, config)
        .then(({ data }) => (data ? objectPath.get(data, dataKey) : []))
        .catch(() => [])
    }
    return []
  }

  const createTableColumn = () => {
    if (!tableColumnList) return []
    let newColumn = []
    let newColumnRequire = []

    let filterColumn = tableColumnList.filter(
      ({ typeField }) => typeField !== 'system',
    )
    filterColumn.forEach((column, index) => {
      column = { ...column }
      let type = column?.typeField || column?.type
      let conditions = column?.conditions || []
      let isHideFromActiveTab = conditions.find(
        ({ valueType, tabKey, value, actionColumn }) => {
          if (valueType !== 'tab') return
          if (actionColumn !== 'hide') return
          let tabUi = getCurrentUi(value, jsonForm.schema, jsonForm.uischema)
          if (tabUi.key === value) {
            let tabName = tabUi.name
            let isActiveTab =
              objectPath.get(isUiChanged, ['activeTab', tabKey]) == tabName
            return isActiveTab
          }
          return
        },
      )
      if (isHideFromActiveTab) return

      if (column?.isLock) {
        column.editable = 'onAdd'
      }
      if (column?.isRequired) {
        column.validate = (rowData) => {
          let value = objectPath.get(rowData, column.field)
          return isEmpty(value) ? { isValid: false } : true
        }
        if (!newColumnRequire.includes(column.field))
          newColumnRequire.push(column.field)
      }
      if (column?.field === uischema?.sortField) {
        column.defaultSort = uischema.defaultSort || 'asc'
        column.sorting = true
      } else {
        delete column.defaultSort
      }
      column.type = type
      column = createTableStyle(column, uischema)
      objectPath.set(column, 'tableData.columnOrder', index)
      newColumn.push(column)
    })
    setTableColumn(newColumn)
    setColumnRequire(newColumnRequire)
  }

  useEffect(createTableColumn, [
    tableColumnListString,
    uischema.rowPadding,
    uischema.defaultSort,
    uischema.sortField,
    activeTabStateString,
  ])

  const checkTableLength = (tableData) => {
    let tableLength = tableData.length
    if (tableLength < startRow) {
      let diffLength = startRow - tableLength
      tableData = addStartRow(cloneDeep(tableData), diffLength)
    }
    setTableData(tableData)
  }

  useEffect(() => {
    let isMounted = true
    const fetchTableData = async () => {
      let tableData = []
      let filterApi = checkCrudCondition({
        action: uischema.loadData,
        designContext,
        allParams,
      })
      if (isFavoriteModal) {
        tableData = config.jsonData
      } else if (filterApi?.length > 0) {
        let action = filterApi[0]
        let api = getLoadTableApi(action)
        let hasCache = hasTableCache(api)
        tableData = hasCache
          ? getTableCache(api)
          : (await loadTableData(action, api)) || []
        if (!isMounted) return
        if (!hasCache) setTableCache(api, tableData)
      } else {
        tableData =
          objectPath.get(formData, uischema.name) ||
          objectPath.get(formData, uischema.key) ||
          []
      }
      if (!isMounted) return
      checkTableLength(tableData)
      onCheckCondition(designContext, formData, uischema.key)
    }

    fetchTableData()
    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    if (isRenderTable) {
      checkTableLength(isRenderTable)
      setTableCache(getCurrentTableCacheKey(), isRenderTable, false)
      objectPath.del(isUiChanged, [`isRenderTable`, uischema.key])
      setIsUiChanged(isUiChanged)
    }
  }, [isRenderTable])

  const classes = useStyles()

  return (
    <Paper>
      <MTableButton {...props} handleAdd={handleAdd} />
      <TableContainer>
        <div
          style={{
            maxHeight: uischema.maxHeight || '100%',
            minHeight: uischema.minHeight || 'auto',
            overflowY: 'auto',
          }}
        >
          <Table>
            <MTableHead
              {...props}
              tableColumn={tableColumn}
              showAction={isEnable ?? showAction}
              isActiveUpdate={isActiveUpdate}
              isActiveDelete={isActiveDelete}
              activeIcon={activeIcon}
              activeOptional={activeOptional}
              isReadOnly={isReadOnly}
            />
            <MTableBody
              {...props}
              search={search}
              tableData={tableData}
              setTableData={setTableData}
              setPage={setPage}
              page={page}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              tableColumn={tableColumn}
              columnRequire={columnRequire}
              addState={addState}
              editData={editData}
              setEditData={setEditData}
              showAction={isEnable ?? showAction}
              isActiveUpdate={isActiveUpdate}
              isActiveDelete={isActiveDelete}
              activeIcon={activeIcon}
              activeOptional={activeOptional}
              onDeleteRow={handleDelete}
              onEditRow={onEditRow}
              isReadOnly={isReadOnly}
              openModalTable={openModalTable}
              stateParent={stateParent}
            />
          </Table>
        </div>
      </TableContainer>

      {isPaging && (
        <TablePagination
          component="div"
          count={count}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={rowsPerPageOptions}
          ActionsComponent={ActionsComponent}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                className: classes.selectMenuPaper,
              },
              MenuListProps: {
                className: classes.selectMenuList,
              },
            },
          }}
        />
      )}

      <ModalTable
        state={modalTableState}
        setState={setModalTableState}
        ui={uischema}
        modalAction={modalAction}
        isOpenModal={openModalTable}
        setIsOpenModal={setOpenModalTable}
        onRefreshTable={() => {}}
        dataRowSelected={dataRowSelected}
        designerPropsData={designerPropsData}
      />
    </Paper>
  )
}

export default MTableArray
